import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { roundBonusRepository } from "@/config/dataSource";
import type { RoundBonusType } from "@/modules/leagues/types/roundBonus";

export function useRoundBonuses(leagueId: string, round: number | undefined) {
  return useQuery({
    queryKey: ["round-bonuses", leagueId, round ?? "unknown"],
    queryFn: () => roundBonusRepository.getRoundBonuses(leagueId, round as number),
    enabled: round !== undefined,
  });
}

export function useSetRoundBonus(leagueId: string, round: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ matchId, type }: { matchId: string; type: RoundBonusType | null }) =>
      roundBonusRepository.setRoundBonus(leagueId, matchId, round as number, type),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["round-bonuses", leagueId, round ?? "unknown"] });
    },
  });
}
